import React, { useEffect, useState, useRef, forwardRef, useImperativeHandle } from 'react';
import './style.scss';
import { Toast } from 'antd-mobile';
import {hideLoading, showLoading} from "@/components/loading";
import ListView from '@/components/AntListView';
import { queryAppointTypeCollection } from '@/api/projectManager_self';
import { mockFn } from './mock';

const MedicineList = forwardRef((props, ref) => {
  const { getMedicine, renderStatus } = props;
  const [medicineList, setMedicineList] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const [initStatus, setInitStatus] = useState(false);
  const currentPage = useRef(1);
  const pageSize = useRef(20);
  const chooseMedicineDataRef = useRef({nftNo: '', imageBg: ''});
  const userInfo = JSON.parse(window.localStorage.getItem('userInfo'));

  useImperativeHandle(ref, () => {
    return {
      chosseMedicine: chosseMedicine,
      getMedicineList: getMedicineList
    }
  })

  useEffect(() => {
    if (!initStatus && renderStatus) {
      setInitStatus(true);
      getMedicineList();
      return;
    }
  }, [initStatus, renderStatus]);

  const getMedicineList = async (isRefresh=true, isLoading=true) => {
    try {
      if(isRefresh) {
        currentPage.current = 1;
      } else {
        currentPage.current = currentPage.current + 1;
      }
      const params = {
        current: currentPage.current,
        size: pageSize.current,
        collectionType: 30,
        clientId: userInfo?.clientId
      }
      isLoading && showLoading();
      const res = await queryAppointTypeCollection(params);
      // const res = await mockFn(30);
      isLoading && hideLoading();
      if (res.code !== '000000') throw res.msg;
      if(currentPage.current === 1) {
        setMedicineList(res.data.nftComponentVO);
      } else {
        setMedicineList([...medicineList, ...res.data.nftComponentVO]);
      }
      isRefresh && setIsLoad(true);
      setHasMore(res.data.total > [...medicineList, ...res.data.nftComponentVO].length);
    } catch (error) {
      isLoading && hideLoading();
      Toast.show(error);
    }
  }

  const chosseMedicine = (item) => {
    const newList = medicineList.map((i) => {
      if(i.id === item.id) {
        return {...i, isChoosed: !i.isChoosed}
      } else {
        return {...i, isChoosed: false};
      }
    })
    if(chooseMedicineDataRef.current.id === item.id) {
      chooseMedicineDataRef.current = {nftNo: '', imageBg: ''};
    } else {
      chooseMedicineDataRef.current = item;
    }
    setMedicineList(newList);
    getMedicine(chooseMedicineDataRef.current);
  }

  const RenderItem = (item) => {
    return <div 
      className={`container-item ${item.isChoosed ? 'active': ''}`} 
      onClick={() => chosseMedicine(item)}
    >
      <span className='collection-num'>#{item.nftNo}</span>
      <img src={item.imageBg} alt="" />
    </div>
  }

  return <div className='medicine-list-container' ref={ref}>
    <ListView 
      dataSource={medicineList}
      renderItem={RenderItem}
      hasMore={hasMore}
      onEndReached={() => getMedicineList(false, false)}
      style={{paddingTop: 30}}
      isLoad={isLoad}
    />
  </div>
})

export default MedicineList;